// Copyright (c) 2016 Deere & Company

import * as fetchService from '../services/fetch';
import {handleError} from '../services/error-handlers.js';

const basePath = '/api';

export async function deleteExcelLayout(name, listId) {

    const endPoint = `${basePath}/excel-layouts/${encodeURIComponent(name)}?listId=${listId}`;

    const options = {
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return handleError(response);

    }

}

export async function getFile(file) {

    const endPoint = `${basePath}/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}`;

    try {

        return await fetchService.fetch(endPoint);

    } catch (error) {

        return handleError(error);

    }

}

export async function getFileRga(file) {

    const endPoint = `${basePath}/files/${encodeURIComponent(file.fileName)}?serialNumber=${file.serialNumber}&className=${file.className}&classType=${file.classType}&objectKey=${file.objectKey}&requestedSource=RGA_DATA_MART`;

    try {

        return await fetchService.fetch(endPoint);

    } catch (error) {

        return handleError(error);

    }

}

export async function getFileTemplateRgaMassUpload() {

    const endPoint = `${basePath}/rga/download-template`;

    try {

        return await fetchService.fetch(endPoint);

    } catch (error) {

        return handleError(error);

    }

}

export async function getBranchConstants() {

    const endPoint = `${basePath}/constants?id=BRANCH`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getClaimTypes() {

    const endPoint = `${basePath}/constants?id=CLAIM_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getComponentCodes() {

    const endPoint = `${basePath}/constants?id=COMP_DESC`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getCreditMemoClaims(claimNumbers, language) {

    const endPoint = `${basePath}/smart-forms/batch`;

    try {

        const postParams = {
            formName: 'CLAIM',
            language,
            objectIds: claimNumbers
        };

        const options = {
            body: JSON.stringify(postParams),
            method: 'POST'
        };

        return await fetchService.fetch(endPoint, options);

    } catch (error) {

        return handleError(error);

    }

}

export async function getCreditMemos(memoNumbers, language) {

    const endPoint = `${basePath}/smart-forms/batch`;

    try {

        const postParams = {
            formName: 'CREDITMEMO',
            language,
            objectIds: memoNumbers
        };

        const options = {
            body: JSON.stringify(postParams),
            method: 'POST'
        };

        return await fetchService.fetch(endPoint, options);

    } catch (error) {

        return handleError(error);

    }

}

export async function getCustomer(id, customerPrivate) {

    const endPoint = customerPrivate ?
        `${basePath}/customers/${id}?customerPrivate=${customerPrivate}` :
        `${basePath}/customers/${id}`;

    const options = {
        endpointId: 'sap-status'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getCustomerByCkcId(ckcId) {

    const endPoint = `${basePath}/ckc-customers/${ckcId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getExcelLayouts(listId) {

    const endPoint = `${basePath}/excel-layouts?listId=${listId}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getFactoryCodeConstants() {

    const endPoint = `${basePath}/constants?id=FACTORY`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function saveAddedAmountOfUse(addAmountOfUse, pin) {

    const endPoint = `${basePath}/products/${pin}/measurement-readings`;

    const options = {
        body: JSON.stringify(addAmountOfUse),
        method: 'POST'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}

export async function getLatestPerUnitMeasurements(pin) {

    const endPoint = `${basePath}/products/${pin}/measurement-readings?latestPerUnit=true&isTcsm=false`;

    const options = {
        endpointId: 'measurement-readings'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getLinks(language) {

    const endPoint = `${basePath}/links/${language}`;
    const options = {
        cloudPreferred: true,
        endpointId: 'links'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getSmartForm(formName, objectId, language) {

    const endPoint = `${basePath}/smart-forms/${formName}?objectId=${objectId}&language=${language}`;

    try {

        return await fetchService.fetch(endPoint);

    } catch (error) {

        return handleError(error);

    }

}

export async function getStatusConstants() {

    const endPoint = `${basePath}/constants?id=DEMO_RENT_STATUS`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getSubClaimTypes() {

    const endPoint = `${basePath}/constants?id=SUBCLAIM_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getWarrantyTypesList() {

    const endPoint = `${basePath}/constants?id=WARRANTY_TYPE`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function saveExcelLayout(excelLayout) {

    const endPoint = `${basePath}/excel-layouts`;

    try {

        const options = {
            body: JSON.stringify(excelLayout),
            method: 'POST'
        };

        return await fetchService.fetch(endPoint, options);

    } catch (error) {

        return handleError(error);

    }

}

export async function updateCustomer(ckcId, id) {

    const endPoint = `${basePath}/customers/${id}`;

    const payload = {
        ckcId
    };

    try {

        const response = await fetchService.fetch(endPoint,
            {
                body: JSON.stringify(payload),
                method: 'PUT'
            });

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function getExcelForDownload(url) {

    try {

        return await fetchService.fetch(url);

    } catch (error) {

        return handleError(error);

    }

}

export async function getFavorites(userId) {

    const endPoint = `${basePath}/users/${userId}/favorites`;
    const options = {
        cloudPreferred: true,
        endpointId: 'favorites'
    };

    try {

        const response = await fetchService.fetch(endPoint, options);

        return response.json();

    } catch (error) {

        return handleError(error);

    }

}

export async function deleteFavorite(userId, id) {

    const endPoint = `${basePath}/users/${userId}/favorites/${id}`;
    const options = {
        cloudPreferred: true,
        endpointId: 'favorites',
        method: 'DELETE'
    };

    try {

        return await fetchService.fetch(endPoint, options);

    } catch (response) {

        return (response.status === 404 || response.status === 406) ? Promise.reject(response) : handleError(response);

    }

}

export async function updateFavorite(userId, payload) {

    const endPoint = `${basePath}/users/${userId}/favorites`;

    try {

        const options = {
            body: JSON.stringify(payload),
            cloudPreferred: true,
            endpointId: 'favorites',
            method: 'POST'
        };

        return await fetchService.fetch(endPoint, options);

    } catch (error) {

        return (error.status === 404 || error.status === 406) ? Promise.reject(error) : handleError(error);

    }

}



// WEBPACK FOOTER //
// ./src/shared/repositories/index.js